import { AnyMenuItem, BrandResource, DynamicConfigState, useDynamicConfig } from "@dgs/core";
import { TStartPageBehaviour } from "../../../shared/types/configurations";
import { Currency } from "../../../shared/types/currency";

export interface FrontendConfig extends DynamicConfigState {
	apiUrl: string;
	authUrl: string;
	userUrl: string;
	logo: string;
	company: string;
	contactName: string | null;
	contactEmail: string | null;
	appIdentifier: string | null;
	brand: BrandResource | null;
	defaultCurrency: Currency;
	productTranslations: { locale: string; value: string }[];
	startPageBehaviour: TStartPageBehaviour;
	menuItem: AnyMenuItem | null;
}

export const useFrontendConfig = () => {
	return useDynamicConfig() as FrontendConfig;
};
